import { render, staticRenderFns } from "./FielTable.vue?vue&type=template&id=8316c1be"
import script from "./FielTable.vue?vue&type=script&lang=js"
export * from "./FielTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports